import React from 'react';
import CategoryPage from '../../categories/CategoryPage';

function Anexo30Y31Ano2022SistemasDeMedicion() {
  return <CategoryPage category="anexo30Y31Ano2022SistemasDeMedicion" pageTitle="Sistemas De Medicion 2022" />;
}

export default Anexo30Y31Ano2022SistemasDeMedicion;
